import React from 'react';
import { BsFileEarmarkPdf } from "react-icons/bs";
import { Link } from 'react-router-dom';

const Attachments = ({...props}) => {
    const attachments = props.attachments;
    return (
        <div className='flex flex-col py-4 px-7 bg-white box-shadow rounded-xl'>
            <h2 className='text-xl leading-8 font-bold uppercase font-montserrat pb-2 mb-4 text-gray-900 text-center border-b border-gray-200 border-solid'>Attachments</h2>
            <div className='flex flex-wrap gap-4 items-start justify-center'>
                {attachments.map((attachments, idx)=>(
                <div key={idx} className='w-full max-w-80 flex flex-col justify-center items-center space-y-3 p-5 rounded-lg border border-solid border-gray-200 bg-gray-950 bg-opacity-[0.04]'>
                    <BsFileEarmarkPdf className='text-5xl text-red-800' />
                    <div className=''>{attachments.title}</div>
                    <Link to={attachments.url} download target="_blank" rel="noopener noreferrer" className='inline-flex items-center justify-center text-center text-decoration-none cursor-pointer px-4 py-2 font-normal bg-orange-500 border border-orange-500 text-white hover:bg-sky-950 hover:border-sky-950'>View & Download</Link>
                </div>
                ))}
            </div>
        </div>
    );
}

export default Attachments;
